<template>
  <div>
    <custom-callout
      :border-color="statusColor.color"
      class-main="mt-3 rounded"
      :has-toggle="false"
    >
      <div class="row py-2 mr-md-0 align-items-center">
        <div class="col col-sm-3 col-12 mt-3 mt-md-0">
          <div class="color-gray-6 font-14">Especialista:</div>
          <div class="color-black font-16">
            {{ data.fullName | empty }}
          </div>
        </div>
        <div class="col col-sm-2 col-12 mt-3 mt-md-0">
          <div class="color-gray-6 font-14">Número de Especialista:</div>
          <div class="color-black font-16">
            {{ data.specialistId | empty }}
          </div>
        </div>
        <div class="col col-sm-3 col-12 mt-3 mt-md-0">
          <div class="color-gray-6 font-14">Especialidad:</div>
          <div class="color-black font-16">
            {{ data.specialties ? data.specialties.join(', ') : '' | empty }}
          </div>
        </div>
        <div class="col col-sm col-12 mt-3 mt-md-0">
          <div class="color-gray-6 font-14">Estatus:</div>
          <div class="color-black font-16">
            <span class="circle-dot mr-2" :style="`${statusColor.badged}`" />
            {{ statusName | empty }}
          </div>
        </div>
        <div
          class="col col-sm col-12 d-flex align-items-center justify-content-end"
        >
          <action-button
            class="button-action-size"
            i="fas fa-file-import"
            text="Entrar"
            variant="outline-success m-2 px-4"
            @click="$emit('on-view-specialist')"
          />
        </div>
      </div>
    </custom-callout>
    <div
      v-if="alertText(data)"
      class="alert rb-alert px-2 rounded pt-2 mb-n0 alert-container mb-3"
    >
      <div class="d-flex align-items-center">
        <em
          class="fa fa-bell-exclamation font-16 pl-2 ml-1 color-secondary-40"
        />
        <div
          class="font-16 font-weight-normal color-secondary-40 ml-3 alert-text"
        >
          <div v-html="alertText(data)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import ServiceStatusColors from '@/utils/constants/requestServiceStatusColors';
import SpecialistState from '@/utils/constants/specialistState.js';
import ActionButton from 'ActionButton';
import { ExemptionStatuses } from '@/utils/constants/ExemptionStatuses';

export default {
  name: 'SpecialistResultRow',
  components: {
    CustomCallout,
    ActionButton,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    alertText(item) {
      let text = '';

      if (item.exemptionStatusId === ExemptionStatuses.Sometida) {
        text =
          '<p class="mb-0">Especialista se encuentra en proceso de aprobación de dispensa por parte del Departamento de Educación de Puerto Rico.</p>';
      } else if (item.exemptionStatusId === ExemptionStatuses.Aprobada) {
        text =
          '<p class="mb-0">La dispensa fue aprobada por el Departamento de Educación de Puerto Rico.</p>';
      } else if (item.exemptionStatusId === ExemptionStatuses.Denegada) {
        text =
          '<p class="mb-0">La dispensa fue denegada por el Departamento de Educación de Puerto Rico.</p>';
      }
      return text;
    },
  },
  computed: {
    statusColor() {
      switch (this.data.status) {
        case SpecialistState.Inactive:
          return {
            color: ServiceStatusColors.Yellow,
            badged: 'background-color: #f8ea80',
          };
        case SpecialistState.Active:
          return {
            color: ServiceStatusColors.GreenLight,
            badged: 'background-color: #A3E5B3',
          };
        default:
          return null;
      }
    },
    statusName() {
      return this.data.status === SpecialistState.Inactive
        ? 'Inactivo'
        : 'Activo';
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.rb-alert {
  background-color: #feeeb7;
  border: 1px solid #fdac41;
  border-top: 0px;
  border-radius: 0px 0px 5px 5px !important;
  .alert-text,
  .fa-bell-exclamation {
    color: #af6708;
  }
}

.text-dark-yellow {
  color: #af6717;
}

.circle-dot {
  height: 7px;
  width: 7px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
}
.button-action-size {
  width: 125px;
  height: 36px;
  background-color: map-get($colors, 'secondary-3') !important;
}
.button-action-size:hover {
  background-color: map-get($colors, 'green') !important;
}

//button size mobile
@media (max-width: 576px) {
  .button-action-size {
    width: 100%;
    height: 36px;
    background-color: map-get($colors, 'secondary-3') !important;
  }
}
</style>
